import ErrorIcon from '@mui/icons-material/Error';

import MessageModal from 'app/components/MessageModal';

const ErrorModal = props => {
  const { error, onClose } = props;
  const isOpen = !!error;
  const title = 'Error';
  const headerVariant = 'h6';
  const headerIcon = <ErrorIcon />;

  let message = null;
  if (isOpen) {
    // log error with stacktrace
    console.error(error);

    if (typeof error === 'string') {
      message = error;
    } else {
      message = error.message || error.error || JSON.stringify(error);
    }
  }

  const secondaryButtonLabel = 'Help';
  const secondaryButtonIcon = null;
  const onSecondaryButtonClick = () => {};

  let onCloseWrapper = () => {
    try {
      onClose();
    } catch(err) {
      console.error(err);
    }
  }

  return (
    <MessageModal
      isOpen={isOpen}
      onClose={onCloseWrapper}
      title={title}
      headerVariant={headerVariant}
      headerIcon={headerIcon}
      message={message}
      secondaryButtonLabel={secondaryButtonLabel}
      secondaryButtonIcon={secondaryButtonIcon}
      onSecondaryButtonClick={onSecondaryButtonClick}
    />
  );
}

export default ErrorModal;
